// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询资产列表 GET /api/v1/assets */
export async function AssetControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAssetDtoArray>("/api/v1/assets", {
    method: "GET",
    params: {
      // pageSize has a default value: 10
      pageSize: "10",

      // logicOperator has a default value: and
      logicOperator: "and",

      // sortOrder has a default value: DESC
      sortOrder: "DESC",

      ...params,
    },
    ...(options || {}),
  });
}

/** 创建资产 POST /api/v1/assets */
export async function AssetControllerCreateV1(
  body: MyApi.CreateAssetDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAssetDto>("/api/v1/assets", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询资产详情 GET /api/v1/assets/${param0} */
export async function AssetControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetDto>(`/api/v1/assets/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 更新资产 PUT /api/v1/assets/${param0} */
export async function AssetControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetControllerUpdateV1Params,
  body: MyApi.UpdateAssetDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetDto>(`/api/v1/assets/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 删除资产（软删除） DELETE /api/v1/assets/${param0} */
export async function AssetControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/assets/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 强制解绑资产 POST /api/v1/assets/${param0}/force-unbind */
export async function AssetControllerForceUnbindV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetControllerForceUnbindV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAssetDto>(
    `/api/v1/assets/${param0}/force-unbind`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 批量删除资产（软删除） DELETE /api/v1/assets/batch */
export async function AssetControllerBatchRemoveV1(
  body: MyApi.BatchDeleteAssetDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/assets/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量调拨资产（从 A 门店调至 B 门店） POST /api/v1/assets/batch-transfer */
export async function AssetControllerBatchTransferV1(
  body: MyApi.BatchTransferAssetDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBatchTransferAssetResultDto>(
    "/api/v1/assets/batch-transfer",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 分页查询已删除资产（回收站） GET /api/v1/assets/deleted */
export async function AssetControllerListDeletedV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AssetControllerListDeletedV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputDeletedAssetDtoArray>(
    "/api/v1/assets/deleted",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}
